// tslint:disable:nx-enforce-module-boundaries
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_API_TOKEN } from '@epicuro-next/data/product';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BarcodeSearchResult, ProductBarcode } from '../interfaces';
import { barcodesMapper } from '../utils/barcodes-mapper';

/**
 * Service to manage the product lists
 */
@Injectable()
export class ProductListService {
  /**
   * Dependencies
   */
  constructor(
    private httpClient: HttpClient,
    @Inject(PRODUCTS_API_TOKEN) private productsApiUrl: string,
  ) {}

  public getProductsByBarcodes(
    accountId: string,
    barcodes: string[],
    full = false,
  ): Observable<BarcodeSearchResult[]> {
    const url = `${this.productsApiUrl}/${accountId}/product/barcode?full=${full}`;
    return this.httpClient
      .post<ProductBarcode>(url, barcodes)
      .pipe(map(barcodesMapper));
  }
}
